export const filterByFields = (data: any, searchTerm: any, fields: string[]) => {
  const lowerSearch = searchTerm.toLowerCase();

  return data.filter((obj: any) =>
    fields.some((field) => typeof obj[field] === 'string' && obj[field].toLowerCase().includes(lowerSearch))
  );
};
